<template>
    <div>
        <default-navigation></default-navigation>
        <section>
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-7">
                        <h1 class="mb-5">Beoordeel niet-cliëntgebonden <br>activiteiten op fysieke (over)belasting</h1>
                        <p>Met deze gratis RisicoRadar kunt u online onderzoek doen naar de fysieke belasting (tillen, duwen, reiken, dragen, trekken etc.) van medewerkers die niet-cliëntgebonden
                           werkzaamheden
                           verrichten in uw zorgorganisatie. Denk daarbij aan de technische dienst, logistiek, restaurant, balie, etc. </p>
                        <p>U zet de vragenlijst via een e-mail uit bij een groep medewerkers die u zelf selecteert en u krijgt de resultaten in een grafiek en een tabel op uw scherm. In een oogopslag ziet u
                           of er sprake is van fysieke overbelasting en bij welke werkzaamheden dat gebeurt. </p>
                        <p class="mb-5">Goed om te weten: de RisicoRadar toetst de werkzaamheden aan de hand van de Praktijkrichtlijnen Fysieke Belasting zoals ze voor uw branche zijn vastgelegd. </p>
                        <router-link to="/start-onderzoek" class="btn btn-primary mb-3">Start een onderzoek*</router-link>
                        <p class="sub italic gray-500">* Deze RisicoRadar is ontwikkeld en bedoeld voor medewerkers, die niet-cliëntgebonden taken verrichten en werkzaam zijn in de universitaire
                                                       medische
                                                       centra, de algemene ziekenhuizen en de gehandicaptenzorg. </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>
